export enum BrandsEnum {
  FEAZEL = 'feazel',
  KEARNS = 'kearns',
  KEARNS_BROTHERS = 'kearnsbrothers',
  SHANCO = 'shanco',
  MUSIC_CITY_ROOFERS = 'musiccityroofers',
}
